import React from "react";
import Payment from "./subcomponents/Payment";
import PhoneValidation from "./subcomponents/phoneValidation";
import Plan from "./subcomponents/Plan";
import RegistrationConfirmationPage from "./subcomponents/success";
import User from "./subcomponents/User";
const Components = {
  user: User,
  validatePhone: PhoneValidation,
  plan: Plan,
  payment: Payment,
  success: RegistrationConfirmationPage
};

const RegistrationBuilder = (block) => {
  if (typeof Components[block[0]] !== "undefined") {
    if (block[1]) {
      return React.createElement(
        Components[block[0]],
        {
          data: block[1],
          functions: block[2],
        },
        React.createElement("div", { id: `${block[0]}` })
      );
    }
    return React.createElement(() => <div>Missing Block Data</div>);
  }
  return React.createElement(
    () => <div>The component {block[0]} has not been created yet.</div>,
    { key: block._uid }
  );
};

export default RegistrationBuilder;
